import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './utils/myStore'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.store = store

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
